export default __webpack_public_path__ + "static/media/payment-status-icon.af9ecc3a.svg";